import { ComponentConfig } from "@measured/puck"
import CKEditorComponent from "../../../../../../lib/Ckeditor"
import { RelationshipLayoutProps, RenderConfig } from "./RenderConfig"

export const RelationshipLayout: ComponentConfig<RelationshipLayoutProps> = {
  label: "SKE | Relationship Layout",
  fields: {
    items: {
      label: "List items",
      type: "array",
      max: 3,
      min: 3,
      arrayFields: {
        title: {
          label: "Title",
          type: "custom",
          render: ({ value, onChange }) => {
            return <CKEditorComponent value={value || ""} onChange={onChange} />
          },
        },
        description: {
          label: "Sub Description",
          type: "array",
          arrayFields: {
            content: {
              label: "Content",
              type: "custom",
              render: ({ value, onChange }) => {
                return <CKEditorComponent value={value || ""} onChange={onChange} />
              },
            },
          },
        },
      },
    },
  },
  defaultProps: {
    items: [
      {
        id: 1,
        title: "Title 1",
        description: [{ content: "Lorem ipsum dolor sit amet" }],
      },
    ],
    height: 500,
  },
  ...RenderConfig,
}
